var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carro-guia"},[_c('vuestic-modal',{attrs:{"large":true}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Carro Guia")]),_c('table',{staticClass:"table table-info"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }